import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google'
import config from 'services/config'

import socialLoginApi from '../../../services/api/socialLogin'
import styles from './Google.module.scss'

const LoginWithGoogleButton = ({ onSuccess, onError }) => {
  const clientId = config.googleClientId

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className={styles.googleContainer}>
        <GoogleLogin
          width={460}
          logo_alignment="center"
          padding="10px 0"
          css={{ background: 'yellow' }}
          onSuccess={res => {
            socialLoginApi
              .google({
                GoogleIdToken: res.credential
              })
              .then(res => {
                onSuccess && onSuccess(res)
              })
              .catch(err => {
                onError && onError(err)
              })
          }}
          onError={() => {
            console.warn('Login Failed')
          }}
        />
      </div>
    </GoogleOAuthProvider>
  )
}

export default LoginWithGoogleButton
